import React, { useState, useEffect } from "react";
import Select from "react-select";
import CardLayout from "../../common/cardLayout/CardLayout";
import { useDispatch, useSelector } from "react-redux";
import {
  getStaffLogic,
  setSelectedClinic,
  setProvider,
} from "../../../store/features/app/appSlice";
import SidebarLayout from "../../common/sidebar/SidebarLayout";
import { Helmet } from "../../common/Helmet";
import { getFullName } from "../../../util/helpers";

const SelectClinic = (props) => {
  const { staffDataLoading, staffData, user, loading } = useSelector(
    (state) => state.app
  );
  const [clinics, setClinics] = useState([]);
  const [localSelectedClinic, setSelectedClinicLocal] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [bhiManagers, setBhiManagers] = useState(null);
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user && !loading) {
      const temp = user?.clinic_pin?.map((clinic) => {
        return {
          label: clinic?.clinic?.name,
          value: clinic,
        };
      });
      setClinics(temp);
      if (staffData.length === 0) {
        dispatch(getStaffLogic());
      }
    }
  }, [user]);

  const setClinicLogic = () => {
    // console.log("selectedProvider?.value",selectedProvider?.value)
    dispatch(setSelectedClinic(localSelectedClinic?.value));
    dispatch(setProvider(selectedProvider?.value));
  };
  const handleManagerChange = (e) => {
    // setSelectedManager(e);
    console.log("handleManagerChange - ", e);
    //setProviders(e);
    setSelectedProvider(e);
    dispatch(setProvider(selectedProvider?.value));
  };

  useEffect(() => {
    if (!localSelectedClinic) {
      return;
    }
    const headManager = {
      label: getFullName(user),
      value: null,
    };
    if (!staffDataLoading && staffData?.length > 0) {
      const clinicians = [
        localSelectedClinic.value?.clinic_admin,
        ...localSelectedClinic.value?.clinical_staff,
      ];
      const tempStaff = staffData
        .map((staff) => {
          if (clinicians?.includes(staff?.id)) {
            if (staff?.id === user?.id) {
              headManager["value"] = staff;
            }
            return {
              label: getFullName(staff),
              value: staff,
            };
          }
        })
        .filter((item) => {
          if (item) {
            return item;
          }
        });
      setBhiManagers(tempStaff);
      setSelectedManager(tempStaff[0]);
    }
    if (localSelectedClinic?.value?.clinic_admin) {
      setProviders([
        //...providers,
        {
          label: localSelectedClinic?.value?.clinic_admin,
          value: localSelectedClinic?.value?.clinic_admin,
        },
      ]);
    }
  }, [localSelectedClinic, staffDataLoading]);

  useEffect(() => {
    // console.log("providers - in useEffect",providers)
    setSelectedProvider(providers[0]);
  }, [providers]);

  return (
    <SidebarLayout {...props}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Select Clinic | Precise Digital</title>
        <link rel="canonical" href={window.location.origin} />
      </Helmet>
      <CardLayout
        className="container col-sm-12 col-md-6 col-lg-6 p-4"
        style={{ marginTop: "15%" }}
      >
        <div className="container-fluid text-left mt-4">
          <h4 className="primary-text-blue">Get Started</h4>
          <span className="secondary-text">
            Select a clinic and provider account to get started
          </span>
        </div>
        <div className="container-fluid">
          <div className="form-input mb-4 w-100">
            <label>Select Clinic</label>
            <Select
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  border: "0px",
                  borderBottom: "1px solid #94A3B8",
                  borderRadius: "0px",
                  padding: "5px",
                }),
              }}
              components={{
                IndicatorSeparator: () => null,
              }}
              placeholder="Select"
              classNamePrefix="select"
              name="clinic"
              value={localSelectedClinic?.clinic?.name}
              onChange={(e) => {
                setSelectedClinicLocal(e);
              }}
              options={clinics}
            />
          </div>
          {user?.role === "CLINICAL_STAFF" && (
            <div className="form-input my-4 w-100">
              <label>Select Provider Account</label>
              <Select
                styles={{
                  control: (baseStyles) => ({
                    ...baseStyles,
                    border: "0px",
                    borderBottom: "1px solid #94A3B8",
                    borderRadius: "0px",
                    padding: "5px",
                  }),
                }}
                components={{
                  IndicatorSeparator: () => null,
                }}
                placeholder="Select"
                classNamePrefix="select"
                name="provider"
                onChange={handleManagerChange}
                options={providers}
                value={selectedProvider}
              />
            </div>
          )}

          <div className="container-fluid text-center my-4">
            <button
              onClick={() => {
                setClinicLogic();
              }}
              style={{ width: "90%" }}
              className="btn primary-btn"
            >
              Start
            </button>
          </div>
        </div>
      </CardLayout>
    </SidebarLayout>
  );
};

export default SelectClinic;
